import { memo, useMemo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { RenderWhen } from 'cng-common/components/renderWhen'
import { useGetFormDataField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations/components/translation'
import { CopiedText } from 'shared/components/copiedText'

import { ContactEditorFormKeys } from '../../configs'
import { ContactEditorSettingFormFields, ContactFormMenuItems } from '../../models'
import { contactEditorTranslation } from '../../translation'

import styles from './ContactFormTitle.module.scss'

type TProps = {
  contact: IContact
}

export const ContactFormTitle = memo<TProps>(({ contact }) => {
  const [currentMenuItem] = useGetFormDataField<ContactFormMenuItems>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.CurrentMenuItem
  )

  const title = useMemo(() => {
    switch (currentMenuItem) {
      case ContactFormMenuItems.Basic:
        return contactEditorTranslation.menu.basic
      case ContactFormMenuItems.Additional:
        return contactEditorTranslation.menu.additional
      case ContactFormMenuItems.UserRights:
        return contactEditorTranslation.menu.userRights
      case ContactFormMenuItems.Campaigns:
        return contactEditorTranslation.menu.campaigns
      case ContactFormMenuItems.ToolAccess:
        return contactEditorTranslation.menu.toolAccess
      case ContactFormMenuItems.ContactRelinking:
        return contactEditorTranslation.menu.contactRelinking
      default:
        return '-'
    }
  }, [currentMenuItem])

  const isDummyContact = contact.contactId.startsWith('new-')

  return (
    <div className={styles.contactFormTitle}>
      <div className={styles.contactSummary}>
        <div className={styles.contactName}>{`${contact.firstName} ${contact.lastName}`}</div>
        <div className={styles.contactAdditional}>
          <div className={styles.label}>
            <Translation text={contactEditorTranslation.header.contactSummury.contactId} span />
          </div>
          <div className={styles.value}>
            <RenderWhen condition={!isDummyContact}>
              <CopiedText>{contact.contactId}</CopiedText>
            </RenderWhen>
            <RenderWhen condition={isDummyContact}>
              <Translation text={contactEditorTranslation.header.default.contactId} span />
            </RenderWhen>
          </div>
          <div className={styles.label}>
            <Translation text={contactEditorTranslation.header.contactSummury.email} span />
          </div>
          <div className={styles.value}>
            <CopiedText>{contact.email}</CopiedText>
          </div>
        </div>
      </div>
      <div className={styles.title}>
        <Translation text={title} span />
      </div>
    </div>
  )
})
